import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { AuthArgs } from '~/api/models/index'

const queries = {
  getAll: {
    queryFn: () => useApi().users.getAllUsers(),
    queryKey: () => ['allUsers']
  }
} as const

const mutations = {} as const

export type UserService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): UserService =>
  defineService(authArgs, {
    queries,
    mutations
  })
